import { useEffect, useState } from 'react';

import { useRecoilValue } from 'recoil';

import {
  manageOrganisationUserTableNameInputState,
  manageOrganisationUserTableEmailInputState,
  manageOrganisationUserTablePermissionState,
  manageOrganisationUserTableTeamsState,
} from 'store';
import { isNameValid } from 'tools';
import { usePermissions } from '../../../api';
import { isNumeric } from '@tq/ui-components';

export const useUserTableCanUpdate = (): boolean => {
  const [canUpdate, setCanUpdate] = useState<boolean>(false);
  const { data: permissionData } = usePermissions();
  const name = useRecoilValue(manageOrganisationUserTableNameInputState);
  const email = useRecoilValue(manageOrganisationUserTableEmailInputState);
  const permissionId = useRecoilValue(manageOrganisationUserTablePermissionState);
  const teamIds = useRecoilValue(manageOrganisationUserTableTeamsState);

  useEffect(() => {
    setCanUpdate(
      isNameValid(name) && isNumeric(permissionId) && permissionId > 0 && teamIds.length > 0
    );
  }, [name, email, permissionId, teamIds, setCanUpdate, permissionData]);

  return !canUpdate;
};
